<template>
  <main-header />
  <section class="hero__section">
    <div class="hero__left">
      <div
        class="hero__banner"
        v-motion
        :initial="{ opacity: 0 }"
        :visibleOnce="{ opacity: 1, transition: { duration: 700 } }"
      >
        <h1>EXPLORE OUR PERSONALIZATION PROCESS</h1>
      </div>
    </div>
    <img class="hero__right" src="../../assets/images/process-hero.jpg" />
  </section>
  <section class="process__section">
    <h2>HOW IT WORKS?</h2>
    <h1
      v-motion
      :initial="{ opacity: 0, y: 20 }"
      :visibleOnce="{ opacity: 1, y: 0, transition: { duration: 400 } }"
    >
      YOU Personalize,
    </h1>
    <h1
      v-motion
      :initial="{ opacity: 0, y: 20 }"
      :visibleOnce="{ opacity: 1, y: 0, transition: { duration: 400 } }"
    >
      WE Deliver
    </h1>
    <div class="process__step">
      <img
        src="../../assets/images/process-image1.svg"
        class="process__icon"
        v-motion
        :initial="{ opacity: 0 }"
        :visibleOnce="{ opacity: 1, transition: { duration: 400, delay: 600 } }"
      />
      <div class="process__number__container">
        <div
          class="process__number"
          v-motion
          :initial="{ opacity: 0 }"
          :visibleOnce="{
            opacity: 1,
            transition: { duration: 400, delay: 400 },
          }"
        >
          01
        </div>
        <div
          class="number__line"
          v-motion
          :initial="{ opacity: 0, x: 50 }"
          :visibleOnce="{ opacity: 1, x: 0, transition: { duration: 400 } }"
        ></div>
      </div>
      <div class="process__description">
        <h3>Choose a Gift Box</h3>
        <p>
          Choose a customizable gift box
          <span>(Accompania, Everlast, Artistico)</span>
        </p>
      </div>
    </div>
    <div class="process__step">
      <div class="process__number__container">
        <div
          class="process__number"
          v-motion
          :initial="{ opacity: 0 }"
          :visibleOnce="{
            opacity: 1,
            transition: { duration: 400, delay: 400 },
          }"
        >
          02
        </div>
        <div
          class="number__line"
          v-motion
          :initial="{ opacity: 0, x: 50 }"
          :visibleOnce="{ opacity: 1, x: 0, transition: { duration: 400 } }"
        ></div>
      </div>
      <div class="process__description">
        <h3>Select Your Journey</h3>
        <p>Love, Gifting, Memorial, Away from home, Wild animal love</p>
      </div>
      <img
        src="../../assets/images/process-image2.svg"
        class="process__icon"
        v-motion
        :initial="{ opacity: 0 }"
        :visibleOnce="{ opacity: 1, transition: { duration: 400, delay: 600 } }"
      />
    </div>
    <div class="process__step">
      <img
        src="../../assets/images/process-image3.svg"
        class="process__icon"
        v-motion
        :initial="{ opacity: 0 }"
        :visibleOnce="{ opacity: 1, transition: { duration: 400, delay: 600 } }"
      />
      <div class="process__number__container">
        <div
          class="process__number"
          v-motion
          :initial="{ opacity: 0 }"
          :visibleOnce="{
            opacity: 1,
            transition: { duration: 400, delay: 400 },
          }"
        >
          03
        </div>
        <div
          class="number__line"
          v-motion
          :initial="{ opacity: 0, x: 50 }"
          :visibleOnce="{ opacity: 1, x: 0, transition: { duration: 400 } }"
        ></div>
      </div>
      <div class="process__description">
        <h3>Customization</h3>
        <p>
          Customize with your preferred level of control (design can be based on
          your pet social media account)
        </p>
      </div>
    </div>
    <div class="process__step">
      <div class="process__number__container">
        <div
          class="process__number"
          v-motion
          :initial="{ opacity: 0 }"
          :visibleOnce="{
            opacity: 1,
            transition: { duration: 400, delay: 400 },
          }"
        >
          04
        </div>
        <div
          class="number__line"
          v-motion
          :initial="{ opacity: 0, x: 50 }"
          :visibleOnce="{ opacity: 1, x: 0, transition: { duration: 400 } }"
        ></div>
      </div>
      <div class="process__description">
        <h3>Add to Cart</h3>
        <p>Add your unique gift box in the shopping cart</p>
      </div>
      <img
        src="../../assets/images/process-image4.svg"
        class="process__icon"
        v-motion
        :initial="{ opacity: 0 }"
        :visibleOnce="{ opacity: 1, transition: { duration: 400, delay: 600 } }"
      />
    </div>
    <div class="process__step">
      <img
        src="../../assets/images/process-image5.svg"
        class="process__icon"
        v-motion
        :initial="{ opacity: 0 }"
        :visibleOnce="{ opacity: 1, transition: { duration: 400, delay: 600 } }"
      />
      <div class="process__number__container">
        <div
          class="process__number"
          v-motion
          :initial="{ opacity: 0 }"
          :visibleOnce="{
            opacity: 1,
            transition: { duration: 400, delay: 400 },
          }"
        >
          05
        </div>
        <div
          class="number__line"
          v-motion
          :initial="{ opacity: 0, x: 50 }"
          :visibleOnce="{ opacity: 1, x: 0, transition: { duration: 400 } }"
        ></div>
      </div>
      <div class="process__description">
        <h3>Pay</h3>
        <p>
          You’re almost there! Get the payment done and the gift box will be
          ready soon
        </p>
      </div>
    </div>
    <div class="process__step">
      <div class="process__number__container">
        <div
          class="process__number"
          v-motion
          :initial="{ opacity: 0 }"
          :visibleOnce="{
            opacity: 1,
            transition: { duration: 400, delay: 400 },
          }"
        >
          06
        </div>
        <div
          class="number__line"
          v-motion
          :initial="{ opacity: 0, x: 50 }"
          :visibleOnce="{ opacity: 1, x: 0, transition: { duration: 400 } }"
        ></div>
      </div>
      <div class="process__description">
        <h3>Get Delivered</h3>
        <p>
          Let’s open a box of happy! Your unique gift box will be delivered to
          your doorstep ​
        </p>
      </div>
      <img
        src="../../assets/images/process-image6.svg"
        class="process__icon"
        v-motion
        :initial="{ opacity: 0 }"
        :visibleOnce="{ opacity: 1, transition: { duration: 400, delay: 600 } }"
      />
    </div>
  </section>
  <main-footer />
</template>

<script>
import SubHeader from "@/components/SubHeader.vue";
import ServiceSection from "@/components/home_components/ServiceSection.vue";
import MainHeader from "@/components/MainHeader.vue";
import MainFooter from "@/components/MainFooter.vue";
export default {
  components: { SubHeader, ServiceSection, MainHeader, MainFooter },
  name: "AboutView",
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Corinthia:wght@400;700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap");

.hero__section {
  background-color: #faf9f8;
  padding: 15rem;
  display: flex;
  justify-content: center;
  align-self: center;
}

.hero__left {
  width: 50%;
  display: flex;
  flex-direction: column;
  gap: 100px;
  justify-content: center;
}
.hero__title {
  display: flex;
  font-family: "Corinthia", serif;
  font-weight: 200;
  font-style: normal;
  font-size: 10rem;
  text-wrap: nowrap;
  align-items: center;
  gap: 32px;
  color: #000;
  line-height: 1;
}

.hero__title hr {
  width: 100%;
  overflow: hidden;
  height: 4px;
  opacity: 1;
  color: #000;
}

.hero__banner {
  background-color: #efddca;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 32px;
  width: 80rem;
  position: relative;
  z-index: 1;
}

.hero__banner h1 {
  font-family: "Baskervville", serif;
  font-size: 7rem;
  line-height: 1.5;
  font-weight: 500;
  color: #000;
}

.hero__right {
  background-color: #000;
  position: relative;
  width: 65rem;
  height: 65rem;
  z-index: 0;
}

.process__section {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f6f1ed;
}

.process__section h2 {
  font-size: 3.5rem;
  color: #bc4749;
  margin-bottom: 24px;
  margin-top: 80px;
}

.process__section h1 {
  font-size: 6rem;
  font-family: "Baskervville", serif;
  line-height: 1.2;
}

.process__step {
  display: flex;
  align-items: start;
  gap: 24px;
  margin-top: 60px;
}

.process__icon {
  width: 250px;
  height: 250px;
}

.process__number__container {
  display: flex;
  align-items: center;
  padding-top: 60px;
}

.process__number {
  font-size: 3rem;
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
  border: 1px solid black;
  border-radius: 100%;
  font-family: "DM Sans", serif;
  font-weight: 500;
}

.number__line {
  width: 80px;
  height: 4px;
  background-color: #000;
}

.process__description {
  width: 220px;
  padding-top: 60px;
}

.process__description h3 {
  font-family: "Baskervville", serif;
  font-size: 3.5rem;
}

.process__description p {
  font-size: 2rem;
  font-weight: 300;
}

.process__description span {
  font-weight: 500;
}

@media (max-width: 1300px) {
  .hero__section {
    overflow: hidden;
  }

  .hero__banner {
    width: 55rem;
  }

  .hero__title {
    font-size: 8rem;
  }

  .hero__banner h1 {
    font-size: 5rem;
  }

  .hero__right {
    width: 55rem;
    height: 55rem;
  }
}

@media (max-width: 920px) {
  .hero__section {
    padding: 100px;
    overflow: hidden;
  }

  .hero__banner {
    width: 35rem;
  }

  .hero__title {
    font-size: 6rem;
  }

  .hero__banner h1 {
    font-size: 3rem;
  }

  .hero__right {
    width: 45rem;
    height: 45rem;
  }
}

@media (max-width: 776px) {
  .hero__section {
    padding: 0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    position: relative;
  }

  .hero__banner {
    width: 70%;
    position: unset;
  }

  .hero__title {
    display: none;
  }

  .hero__banner h1 {
    font-size: 6vw;
  }

  .hero__left {
    position: absolute;
    flex-direction: row;
    justify-content: flex-end;
    gap: 0;
    width: 100%;
    z-index: 1;
    bottom: 4rem;
    right: 0;
  }

  .hero__right {
    aspect-ratio: 1 / 1;
    width: 100%;
    height: auto;
  }

  .process__step {
    gap: 16px;
    margin-top: 60px;
  }

  .process__icon {
    width: 170px;
    height: 170px;
  }

  .process__number__container {
    padding-top: 60px;
  }

  .process__number {
    font-size: 2rem;
    width: 60px;
    height: 60px;
  }

  .number__line {
    width: 50px;
    height: 4px;
    background-color: #000;
  }

  .process__description {
    width: 170px;
    padding-top: 60px;
  }

  .process__description h3 {
    font-family: "Baskervville", serif;
    font-size: 2.5rem;
  }

  .process__description p {
    font-size: 1.5rem;
    font-weight: 300;
  }
}

@media (max-width: 500px) {
  .hero__right {
    width: 120%;
  }

  .process__step {
    gap: 16px;
    margin-top: 60px;
  }

  .process__icon {
    width: 120px;
    height: 120px;
  }

  .process__number__container {
    padding-top: 30px;
  }

  .process__number {
    font-size: 1.6rem;
    width: 40px;
    height: 40px;
  }

  .number__line {
    width: 25px;
    height: 2px;
    background-color: #000;
  }

  .process__description {
    width: 120px;
    padding-top: 30px;
  }

  .process__description h3 {
    font-family: "Baskervville", serif;
    font-size: 2rem;
  }

  .process__description p {
    font-size: 1rem;
    font-weight: 300;
  }

  .process__section h2 {
    font-size: 2rem;
    margin-top: 0px;
  }

  .process__section h1 {
    font-size: 4rem;
  }
}
</style>
